{
  "nameTemplate": "{{name}} Plantilla",
  "editor": "Editor",
  "frequency": "Frecuencia",
  "frequencyTitle": "Frecuencia de generación de informes",
  "oneTimeReportTitle": "Generar un informe único",
  "rules": "Reglas",
  "settings": "Configuración",
  "publish": "publicar",
  "frequencies": {
    "weekly": "Semanal",
    "onceAWeek": "Una vez a la semana",
    "dayOfNextWeek": "día de la semana siguiente (1-7, de lunes a domingo)",
    "monthly": "Mensual",
    "onceAMonth": "Una vez al mes",
    "dayOfNextMonth": "día del mes siguiente (1-28)",
    "quarterly": "Trimestral",
    "onceAQuarter": "Una vez por trimestre",
    "dayOfNextQuarter": "día del primer mes del próximo trimestre (1-28)",
    "yearly": "Anual",
    "onceAYear": "Una vez al año",
    "dayOfNextYear": "día de enero del próximo año (1-28)",
    "outOfBounds": "Fuera de límites",
    "one_time": "Único",
    "oneTimeRange": "Un intervalo de fechas único",
    "oneTimeStart": "Fecha de inicio",
    "oneTimeEnd": "Fecha de finalización"
  },
  "comparisons": {
    "EQUALS": "Igual",
    "NOT_EQUALS": "NO_IGUAL",
    "INCLUDES": "INCLUYE",
    "NOT_INCLUDES": "NO_INCLUYE",
    "IN": "EN",
    "NOT_IN": "NO_EN",
    "GREATER_THAN": "MAYOR_QUE",
    "LESS_THAN": "MENOR_QUE",
    "GREATER_THAN_AGO": "MAYOR_QUE_HACE",
    "LESS_THAN_AGO": "MENOS_QUE_HACE"
  },
  "addRule": "Añadir regla",
  "edit": "Editar",
  "variablesAvailableForThisTemplate": "Variables disponibles para esta plantilla",
  "savedSuccessfully": "Plantilla guardada correctamente",
  "editModal": {
    "title": "Editar plantilla de informe del cliente",
    "type": "Tipo",
    "description": "Descripción",
    "name": "Nombre"
  },
  "newModal": {
    "title": "Plantilla de informe para nuevos clientes",
    "objectType": "Asociación",
    "type": "Tipo",
    "name": "Nombre",
    "reportType": "Tipo de informe",
    "frequency": "Frecuencia",
    "reportTypes": {
      "HTML": "HTML",
      "PAGE_CONFIGURATION": "Configuración de página"
    }
  },
  "updateState": {
    "activate": "Activar",
    "deactivate": "Desactivar",
    "archive": "Archivar",
    "review": "Revisión"
  },
  "settingsTab": {
    "coverPage": {
      "settingsTitle": "Detalles de la portada",
      "title": "Título",
      "subtitle": "Subtítulo",
      "disableBrandColor": "Desactivar el color de la marca",
      "enableCompanyLogo": "Habilitar logotipo de la empresa",
      "enablePreparedBy": "Habilitar preparado por",
      "preparedBy": "Preparado por",
      "enabled": "Habilitar portada"
    },
    "footer": {
      "settingsTitle": "Detalles del pie de página",
      "text": "Texto",
      "enableOnCoverPage": "Habilitar en la portada",
      "enableAlternateCoverPageText": "Habilitar texto alternativo para la portada",
      "alternateCoverPageText": "Texto alternativo de la portada",
      "enabled": "Habilitar pie de página"
    },
    "header": {
      "settingsTitle": "Detalles del encabezado",
      "text": "Texto",
      "enableOnCoverPage": "Habilitar en la portada",
      "enableAlternateCoverPageText": "Habilitar texto alternativo para la portada",
      "alternateCoverPageText": "Texto alternativo de la portada",
      "enabled": "Habilitar encabezado"
    },
    "tableOfContents": {
      "settingsTitle": "Detalles del índice",
      "title": "Título",
      "enabled": "Habilitar índice"
    },
    "general": {
      "settingsTitle": "Detalles generales",
      "brandColor": "Color de marca"
    }
  },
  "clientReport": "Informe del Cliente"
}
